import { useFetch, useListFetch } from '../../../../hooks';
import {
  getScrapingList,
  getShortAgents,
  getCampaigns,
  getStatusMetrics,
} from '../../../../api';
import { ScrapingStatus } from '../const';
import type { TaskStatusValue } from '../../../../api';

const processStringValue = (string: string): string | undefined => {
  if (typeof string !== 'string') return string;
  return string?.length ? string : undefined;
};

export const useScrapingData = () => {
  const { data: agentsOptions } = useFetch(async () => {
    const data = await getShortAgents();

    return (data ?? []).map(d => ({
      value: d.id ?? '',
      label: d.title,
    }));
  }, []);

  const { data: campaignOptionsData } = useFetch(async () => {
    const data = await getCampaigns();
    return (data?.campaigns ?? []).map(name => ({
      value: name,
      label: name,
    }));
  }, []);

  const {
    nodes: scrapingList = [],
    intializing: loadingScraping,
    loading: reloadingScraping,
    refresh,
    filters,
    setFilters,
    setPage,
    pagination,
    reloading,
  } = useListFetch(
    params => {
      const statusFilter = processStringValue(params?.filters?.status);
      const mappedStatus =
        statusFilter === ScrapingStatus.IN_PROCESS
          ? (ScrapingStatus.IN_PROCESS as unknown as TaskStatusValue)
          : (statusFilter as TaskStatusValue) || null;

      return getScrapingList(
        (params?.pagination?.page ?? 1) + 1,
        params?.pagination?.perPage ?? 10,
        processStringValue(params?.filters?.url) || null,
        processStringValue(params?.filters?.campaign_name) || null,
        mappedStatus
      );
    },
    {
      deps: [],
      withQueryParams: true,
    }
  );

  const { data: statusMetrics, loading: loadingStatusMetrics } =
    useFetch(async () => {
      return getStatusMetrics(
        processStringValue(filters?.url) || null,
        processStringValue(filters?.campaign_name) || null
      );
    }, [filters?.url, filters?.campaign_name]);

  return {
    agentsOptions: agentsOptions || [],
    campaignOptions: campaignOptionsData ?? [],
    scrapingList: scrapingList || [],
    loadingScraping,
    reloadingScraping,
    reloading,
    refresh,
    filters,
    setFilters,
    setPage,
    pagination,
    statusMetrics: statusMetrics || null,
    loadingStatusMetrics,
  };
};
